export default "__VITE_ASSET__e11722f2__"